import { useMemo } from 'react';
import { playSound, Sound } from '~/assets/sounds';
import { ISliderLargeProps } from './SliderLarge.model';
import {
	StyledContainer,
	StyledFill,
	StyledMaxButton,
	StyledProgressLine,
	StyledRange,
	StyledTrackWrapper,
} from './SliderLarge.styled';

const SliderLarge: React.FC<ISliderLargeProps> = ({
	min,
	max,
	value,
	step = 1,
	disabled,
	height = 50,
	onChange,
	onMax,
}) => {
	const fillRatio = useMemo(() => {
		if (max === min) {
			return 0;
		}
		const ratio = (value - min) / (max - min);
		if (ratio < 0) return 0;
		if (ratio > 1) return 1;
		return ratio;
	}, [value, min, max]);

	const isMaxed = fillRatio >= 1;

	const fillStyle: React.CSSProperties = isMaxed
		? { width: '100%', transition: 'width 0.1s ease' }
		: {
				width: `calc(20px + (100% - 40px) * ${fillRatio})`,
				transition: 'none',
		  };

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const next = Number(e.target.value);
		onChange(next);
	};

	const handleMaxClick = () => {
		if (disabled || !onMax) {
			return;
		}
		onMax();
		playSound(Sound.ClickButton);
	};

	return (
		<StyledContainer $height={height} $disabled={disabled}>
			<StyledTrackWrapper>
				<StyledFill style={fillStyle} />
				<StyledProgressLine />
				<StyledRange
					$height={height}
					min={min}
					max={max}
					step={step}
					value={value}
					disabled={disabled}
					onChange={handleChange}
					onMouseEnter={() => {
						if (!disabled) {
							playSound(Sound.LinkCursor);
						}
					}}
					tabIndex={-1}
				/>
			</StyledTrackWrapper>
			{onMax && (
				<StyledMaxButton
					onClick={handleMaxClick}
					onMouseEnter={() => {
						if (!disabled) {
							playSound(Sound.LinkCursor);
						}
					}}
					disabled={disabled}
				>
					MAX
				</StyledMaxButton>
			)}
		</StyledContainer>
	);
};

export { SliderLarge };
